<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="hidden-sm-and-up white--text"></v-toolbar-side-icon>
      <v-btn icon @click="goBack()" class="white--text">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">{{ adminId ? 'Edit ' + adminId : 'Add Admin' }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu v-if="adminId" bottom left>
        <v-btn icon slot="activator" class="white--text">
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile @click.stop="openDeleteAdminDialog">
            <v-list-tile-title>Hapus</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-spacer v-else></v-spacer>
    </v-toolbar>
    <v-content>
      <v-layout row wrap>
        <v-flex
          xs12
          text-xs-center
          layout
          align-content-start
          justify-center
          pa-3
        >
          <v-form ref="form" v-model="frmValid">
            <v-text-field
              v-model="txtEmail"
              :rules="[v => !!v || 'E-mail is required', v => /.+@.+/.test(v) || 'E-mail format is invalid']"
              :counter="150"
              label="E-mail"
              required
            ></v-text-field>
            <v-text-field
              v-model="txtPassword"
              :rules="[v => !!v || 'Password is required', v => (v && v.length >= 8) || 'Password must be 8 characters or more']"
              v-if="!adminId"
              label="Password"
              :type="'password'"
              required
            ></v-text-field>
            <v-text-field
              v-model="txtName"
              :rules="[v => !!v || 'Name is required']"
              :counter="100"
              label="Name"
              required
            ></v-text-field>
            <v-text-field
              v-model="txtPhone"
              :counter="14"
              label="Handphone"
            ></v-text-field>
            <v-select
              v-model="cboRole"
              :items="roles"
              :rules="[v => !!v || 'Role is required']"
              item-text="name"
              item-value="roleId"
              label="Role"
              required
            ></v-select>
            <v-btn
              :disabled="!frmValid"
              @click="submit"
            >
              Save
            </v-btn>
            <v-btn v-if="adminId" @click.stop="dialogResetPassword = true">
              Reset Password
            </v-btn>
          </v-form>
          <v-dialog v-model="dialogResetPassword" max-width="300px">
            <v-card>
              <v-card-title>
                <strong>Reset Password</strong>
              </v-card-title>
              <v-card-text>
                <v-form ref="formResetPassword" v-model="frmResetPasswordValid" @submit.prevent="">
                  <v-text-field
                    label="Password"
                    v-model="txtNewPassword"
                    :rules="[v => !!v || 'Password is required', v => (v && v.length >= 8) || 'Password must be 8 characters or more']"
                    :type="'password'"
                    required
                  ></v-text-field>
                  <v-text-field
                    label="Confirm Password"
                    v-model="txtNewPassword2"
                    :rules="[v => !!v || 'Password is required', v => (v && v.length >= 8) || 'Password must be 8 characters or more']"
                    :type="'password'"
                    required
                  ></v-text-field>
                  <v-btn
                    :disabled="!frmResetPasswordValid"
                    @click="submitResetPassword()"
                  >
                    Reset
                  </v-btn>
                </v-form>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>
      <v-dialog
        v-model="dialogDelete"
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">Are you sure to delete this admin?</v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              flat="flat"
              @click="dialogDelete = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="primary"
              flat="flat"
              @click="deleteAdmin();"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>
form {
  width: 100%;
}
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import router from '../router'
import axios from 'axios'

export default {
  props: [
    'adminId'
  ],
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      drawer: false,
      loading: false,
      frmValid: true,
      txtEmail: '',
      txtPassword: '',
      txtName: '',
      txtPhone: '',
      cboRole: null,
      roles: [],
      dialogResetPassword: false,
      dialogDelete: false,
      frmResetPasswordValid: false,
      txtNewPassword: '',
      txtNewPassword2: ''
    }
  },

  mounted () {
    this.openDrawerForDesktop()
    this.getAdmin(this.adminId)
    this.getRoles()
    this.disableBottomDetector()
  },

  methods: {
    openDeleteAdminDialog: function () {
      this.dialogDelete = true
    },
    deleteAdmin: function () {
      this.loading = true
      axios.delete(process.env.VUE_APP_API_ROOT + '/v1/staff/' + this.adminId)
        .then(resp => {
          this.loading = false
          console.log(resp.data)
          if (resp.data.status === 'success') {
            router.push('/admins')
          } else {
            window.alert(resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
            this.loading = false
          }
        })
    },
    getAdmin: function (adminId) {
      if (adminId) {
        this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/staff/' + adminId)
          .then(resp => {
            this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              this.txtEmail = resp.data.data.loginEmail
              this.txtName = resp.data.data.name
              this.txtPhone = resp.data.data.phone
              this.cboRole = resp.data.data.roleId
            } else {
              console.log('unable to load admin details: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + this.$route.fullPath)
              } else if (error.response.status === 403) {
                this.showAlert(error)
              }
              this.loading = false
            }
          })
      }
    },
    getRoles: function () {
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/staff/roles')
        .then(resp => {
          console.log(resp.data)
          if (resp.data.status === 'success') {
            this.roles = resp.data.data
          } else {
            console.log('unable to load roles: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + this.$route.fullPath)
            } else if (error.response.status === 403) {
              this.showAlert(error)
            }
          }
        })
    },
    submit () {
      if (this.$refs.form.validate()) {
        if (this.adminId) {
          this.loading = true
          axios.put(process.env.VUE_APP_API_ROOT + '/v1/staff/' + this.adminId, {
            loginEmail: this.txtEmail,
            name: this.txtName,
            phone: this.txtPhone,
            roleId: this.cboRole
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(resp => {
              this.loading = false
              console.log(resp.data)
              if (resp.data.status === 'success') {
                router.push('/admins')
              } else {
                window.alert(resp.data.message)
              }
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + this.$route.fullPath)
                } else if (error.response.status === 403) {
                  this.showAlert(error)
                }
                this.loading = false
              }
            })
        } else {
          this.loading = true
          axios.post(process.env.VUE_APP_API_ROOT + '/v1/staff', {
            loginEmail: this.txtEmail,
            password: this.txtPassword,
            name: this.txtName,
            phone: this.txtPhone,
            roleId: this.cboRole
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(resp => {
              this.loading = false
              console.log(resp.data)
              if (resp.data.status === 'success') {
                router.push('/admins')
              } else {
                window.alert(resp.data.message)
              }
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + this.$route.fullPath)
                } else if (error.response.status === 403) {
                  this.showAlert(error)
                }
                this.loading = false
              }
            })
        }
      }
    },
    submitResetPassword () {
      if (this.$refs.formResetPassword.validate()) {
        if (this.adminId) {
          if (this.txtNewPassword === this.txtNewPassword2) {
            this.loading = true
            axios.put(process.env.VUE_APP_API_ROOT + '/v1/staff/' + this.adminId, {
              password: this.txtNewPassword
            }, {
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(resp => {
                this.loading = false
                console.log(resp.data)
                if (resp.data.status === 'success') {
                  window.alert('Password has been reset')
                  this.dialogResetPassword = false
                } else {
                  window.alert(resp.data.message)
                }
              })
              .catch(function (error) {
                if (error.response) {
                  console.log(error.response.status)
                  if (error.response.status === 401) {
                    router.push('/login?next=' + this.$route.fullPath)
                  } else if (error.response.status === 403) {
                    this.showAlert(error)
                  }
                  this.loading = false
                }
              })
          } else {
            window.alert('Password mismatch')
          }
        }
      }
    }
  }
}
</script>
